import Geo from '../geometrics.es6'
import Ren from '../ren-shape.es6'

export default class Element {
  constructor ({
    elementTypePattern,
    deviceTyp,
    elementTypeName,
    points,
    status,
    deviceTypes,
    absoluteSizeScale,
    meta
  }) {
    this.elementTypePattern = elementTypePattern
    this.deviceTyp = deviceTyp
    this.elementTypeName = elementTypeName
    this.points = points
    this.status = status
    this.deviceTypes = deviceTypes
    this.absoluteSizeScale = absoluteSizeScale
    this.meta = meta

    // Shapes (returned by render)
    this.shapes = [
      new Ren.Circle({
        name: 'onlineStatus',
        x: 0,
        y: 0,
        radius: 3,
        opacity: 1,
        fill: 'red'
      })
    ]

    // Status properties ((bool) / enum (string) / multi (object of string: bool))
    this.online = this.status ? this.status.online : false
    this.enumError = 'ok' // ok, warn, err (TODO)
  }

  renderShapes (newVariables, deviceTypes) {
    this.setDefaultShapes()
    if (this.status) {
      this.applyStatusOnShapes(newVariables, deviceTypes)
    }
    return this.shapes
  }

  setDefaultShapes () {
    throw new Error('[Element][setDefaultShapes] is abstract')
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status

    // online status
    switch (true) {
      case status.online === null:
      default:
        // status unknown (used for history replay)
        this.modifyShape('onlineStatus', 'fill', '#dedede')
        this.modifyShape('onlineStatus', 'visible', true)
        break
      case !!status.online === false:
          // offline
          this.modifyShape('onlineStatus', 'fill', 'red')
          this.modifyShape('onlineStatus', 'visible', true)
          break
      case !!status.online === true:
        // online
        this.modifyShape('onlineStatus', 'visible', false)
        break
    }
  }

  getLabelPoint (wrapRect, rotation, labelRotation) {
    const point = Element.getRectLabelPoint(wrapRect, labelRotation)
    const rotatedPoint = Geo.rotatePoint(point, rotation)
    const [x = 0, y = 0] = this.points
    return { x: x + rotatedPoint.x, y: y + rotatedPoint.y }
  }

  static getRectLabelPoint ({ x, y, width, height }, labelRotation) {
    const rotate = (labelRotation, phase) =>
      Math.round(10 * (1 - Math.sin(Math.PI / 2 * (labelRotation + phase) / 90)) / 2) / 10
    return {
      x: x + width * rotate(labelRotation, 180),
      y: y + height * rotate(labelRotation, 90)
    }
  }

  modifyShape (shapeName, attrName, val) {
    const shape = this.shapes.find(s => s.attrs.name === shapeName)
    if (shape) {
      shape.setAttr(attrName, val)
    } else {
      console.warn('[element][modifyShape]: Shape not found, name: ' + shapeName)
    }
  }

  // should not be used anymore - index in config field is returned from BE instead
  statusBit (bit) {
    // Returns the asked bit (bit is the order of the bit
    // in the binary representation of the this.status/number
    const number = Number.parseInt(this.status)
    const binary = number.toString(2)
    if (bit < binary.length) {
      if (binary.charAt(binary.length - bit - 1) === '0') {
        // For 0, returns false
        return false
      } else if (binary.charAt(binary.length - bit - 1) === '1') {
        // For 1, returns true
        return true
      }
    }
    // If not found, returns undefined
    return undefined
  }
}
